<div class="preheader" *ngIf="showGlobalMessage">
    <div translate="cart.global.message"></div>
    <button type="button" class="close fa-solid fa-xmark" [attr.aria-label]="'cart.button.close'| translate" (click)="closeGlobalMessage()">
    </button>
</div>

